import { render, staticRenderFns } from "./AddTemplateModal.vue?vue&type=template&id=c4d8a750&scoped=true&"
import script from "./AddTemplateModal.vue?vue&type=script&lang=js&"
export * from "./AddTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplateModal.vue?vue&type=style&index=0&id=c4d8a750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d8a750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d8a750')) {
      api.createRecord('c4d8a750', component.options)
    } else {
      api.reload('c4d8a750', component.options)
    }
    module.hot.accept("./AddTemplateModal.vue?vue&type=template&id=c4d8a750&scoped=true&", function () {
      api.rerender('c4d8a750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/AddTemplateModal.vue"
export default component.exports